(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mn-best-sellers"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-mn-best]').forEach(function (root) {
    root.querySelectorAll('[data-mn-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        root.querySelectorAll('[data-mn-tab]').forEach(function (t) { t.setAttribute('aria-selected', 'false'); });
        root.querySelectorAll('[data-mn-panel]').forEach(function (p) { p.hidden = true; });
        tab.setAttribute('aria-selected', 'true');
        var panel = root.querySelector('[data-mn-panel="' + tab.dataset.mnTab + '"]');
        if (panel) panel.hidden = false;
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
